import { configureStore } from "@reduxjs/toolkit";
import playerReducer from "../features/player/player-slice";
import guildReducer from "../features/guild/guild-slice";

export const store = configureStore({
	reducer: {
		player: playerReducer,
		guild: guildReducer,
	},
});
